import React from 'react';
import classNames from 'classnames';

import { buildOfferHtml } from '../offerDocument';
import css from './OfferPdfButton.module.css';

/**
 * FairwayBid: Öffnet ein einzelnes Angebot als druckfertiges Blatt in einem
 * neuen Fenster. Von dort druckt die Golfanlage es oder sichert es als PDF.
 *
 * Bewusst ein Knopf und kein Link: Es gibt keine Datei auf einem Server, das
 * Dokument entsteht im Browser aus den Daten, die ohnehin schon geladen sind.
 * Damit liegt kein Angebot irgendwo herum, wo es nicht hingehört.
 */
const OfferPdfButton = props => {
  const { offer, listing, clubName = '', total = null, className, label = 'Als PDF' } = props;

  if (!offer) {
    return null;
  }

  const open = () => {
    const html = buildOfferHtml({ offer, listing, clubName, total });
    const win = window.open('', '_blank');
    if (!win) {
      // Pop-up-Blocker. Kein Absturz, aber auch kein stiller Fehlschlag.
      return;
    }
    win.document.open();
    win.document.write(html);
    win.document.close();
  };

  return (
    <button type="button" className={classNames(css.button, className)} onClick={open}>
      {label}
    </button>
  );
};

export default OfferPdfButton;
